import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { VenusModal } from 'src/skins/venus/components/common';
import { DashboardLayout } from 'src/skins/venus/components/layouts';
import { PrivacyPolicyContent } from 'src/skins/common/components';

const Wrapper = styled.div`
  margin-bottom: 3.5rem;
`;

export const PrivacyPolicy = () => {
  const history = useHistory();

  return (
    <DashboardLayout>
      <VenusModal
        isOpen={true}
        closeModal={() => history.replace('/dashboard/settings')}
        fullheight={true}
        backgroundPage="settings"
      >
        <Wrapper>
          <h4>Privacy policy</h4>

          <br />

          <PrivacyPolicyContent />
        </Wrapper>
      </VenusModal>
    </DashboardLayout>
  );
};

export default PrivacyPolicy;
